import cssVars from 'css-vars-ponyfill';
import AreaDownload from "./areaDownload/areaDownload";
import ApprovalPress from "./areaPress/approvalPress";
import AreaPress from "./areaPress/areaPress";
import ArticoliListing from "./articoliListing/articoliListing";
import Configurator from './conf/configurator';
import LavoraConNoi from './lavoraConNoi/lavoraConNoi';
import Login from "./login/login";
import Dom from './shared/dom';
import Popup from './shared/popup';
import Utils from './shared/utils';
import Signup from "./signup/signup";
import Store from './store/store';
import StoreEdit from './storeEdit/storeEdit';
import StoreLocator from './storeLocator/storeLocator';
import StoreLocatorFooterBlock from "./storeLocator/storeLocatorFooterBlock";
import FasciaPromoSignup from "./fasce/fasciaPromoSignup";
import FasciaSignupEventoLondraFSS from "./fasce/fasciaSignupEventoLondraFSS";
import Newsletter from "./newsletter/newsletter";
import NewsletterPopup from "./newsletter/newsletterPopup";
import FasciaPopup from "./fasce/fasciaPopup";
import AreaEditContenutiEdit from "./areaEditContenuti/editContenuto";
import AreaEditContenutiListing from './areaEditContenuti/listingContenuti';
import AreaEditWishlistListing from "./areaEditContenuti/listingWishlist";
import PromoLanding from "./promoLanding/promoLanding";
import StickyBar from './stickyBar/stickyBar';
import FasciaFormSaldiInvernali2024 from "./fasce/fasciaFormSaldiInvernali2024";
import RicercaAgenti from "./ricercaAgenti/ricercaAgenti";

// settings
const debug = true;

window.debug__ = (...args) => {
	if (debug) {
		console.log(...args);
	}
};
window.log__ = (...args) => {
	console.log(...args);
};
window.error__ = (...args) => {
	console.error(...args);
};

export default class App {

	constructor() {}

	init() {
		cssVars();
		log__('%c Coded by Websolute ', 'background: #01c0f6; color: #fff; border-radius: 20px; padding: 10px;');
		const body = document.querySelector('body');
		const page = document.querySelector('.page');
		const header = document.querySelector('.header');

		Dom.detect(body);

		this.body = body;
		this.page = page;
		this.header = header;

		this.onResize();
		this.addListeners();

		Configurator.init();
		Popup.init(document);
		StoreLocator.init();
		StoreLocatorFooterBlock.init();
		StoreEdit.init();
		Store.init();
		LavoraConNoi.init();
		AreaDownload.init();
		AreaPress.init();
		Login.init();
		Signup.init();
		ApprovalPress.init();
		ArticoliListing.init();
		FasciaPromoSignup.init();
        FasciaSignupEventoLondraFSS.init();
        FasciaFormSaldiInvernali2024.init();
		Newsletter.init();
		NewsletterPopup.init();
		FasciaPopup.init();
		AreaEditContenutiEdit.init();
		AreaEditContenutiListing.init();
		AreaEditWishlistListing.init();
		PromoLanding.init();
		StickyBar.init();
        RicercaAgenti.init();
	}

	addListeners() {
		window.addEventListener('resize', () => {
			this.onResize();
		});

		window.addEventListener('scroll', Utils.throttle(() => {
			this.onScroll();
		}, 1000 / 25));

		window.addEventListener('orientationchange', (e) => {
			this.checkDevice();
		});
	}

	onResize() {

	}

	onScroll(e) {

	}

	checkDevice(e) {
		if (Dom.mobile) {
			const html = document.querySelector('html');
			const orientation = window.orientation & 2;
			if (orientation == 0) {
				if (html.classList.contains('landscape')) {
					html.classList.remove('landscape');
				}
				html.classList.add('portrait');
			} else if (orientation == 2) {
				if (html.classList.contains('portrait')) {
					html.classList.remove('portrait');
				}
				html.classList.add('landscape');
			}
		}
	}
}

var app = new App();

window.onload = () => {
	app.init();
};
